/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { isIntegerDependencies } from './dependenciesIsInteger.generated.js';
import { isNegativeDependencies } from './dependenciesIsNegative.generated.js';
import { stirlingS2Dependencies } from './dependenciesStirlingS2.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createBellNumbers } from '../../factoriesAny.js';
export var bellNumbersDependencies = {
  addScalarDependencies,
  isIntegerDependencies,
  isNegativeDependencies,
  stirlingS2Dependencies,
  typedDependencies,
  createBellNumbers
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBellNumbers.generated.js
// module id = 1314
// module chunks = 2